module.exports = __webpack_public_path__ + "static/media/floor4.08fd5ae2.png";